"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    MessageBarContextProvider: function() {
        return MessageBarContextProvider;
    },
    messageBarContextDefaultValue: function() {
        return messageBarContextDefaultValue;
    },
    useMessageBarContext: function() {
        return useMessageBarContext;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const messageBarContext = /*#__PURE__*/ _react.createContext(undefined);
const messageBarContextDefaultValue = {
    titleId: '',
    layout: 'singleline',
    actionsRef: /*#__PURE__*/ _react.createRef(),
    bodyRef: /*#__PURE__*/ _react.createRef()
};
const MessageBarContextProvider = messageBarContext.Provider;
const useMessageBarContext = ()=>{
    var _React_useContext;
    return (_React_useContext = _react.useContext(messageBarContext)) !== null && _React_useContext !== void 0 ? _React_useContext : messageBarContextDefaultValue;
};
